<div class="content-wrapper pt-2">
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Company Profile</div> 
      <form [formGroup] ="companyProfileForm" autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <div class="card-body">  
        <input type="hidden" formControlName="comCode">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="comName" class="col-form-label">Company Name</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-bank"></i></span>
              </div>
              <input type="text" formControlName="comName" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="comName" placeholder="Company Name">
            </div>
            <span class="text-danger" *ngIf="formErrors.comName"><small>{{formErrors.comName}}</small> </span>   
          </div>
        </div>
      </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="registrationNo" class="col-form-label">Registration No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-pencil-square-o"></i></span>
                </div>
                <input type="text" formControlName="regNo" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="registrationNo" placeholder="Registration No">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="taxNo" class="col-form-label">Tax No/ VAT Reg.No </label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                </div>
                <input type="text" formControlName="taxNo" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="taxNo" placeholder="Tax No/ VAT Reg.No">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="svatNo" class="col-form-label">SVAT Reg.No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                </div>
                <input type="text" formControlName="svatNo" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="svatNo" placeholder="SVAT Registration Number">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="mobileNo" class="col-form-label">Mobile No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-mobile-phone"></i></span>
                </div>
                <input type="text" formControlName="mobileNo" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="mobileNo" placeholder="Mobile No">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="phone" class="col-form-label">Telephone</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-phone"></i></span>
                </div>
                <input type="text"  formControlName="phone" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="phone" placeholder="Telephone Number">
              </div>
              <span class="text-danger" *ngIf="formErrors.phone"><small>{{formErrors.phone}}</small> </span>   
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="fax" class="col-form-label">Fax</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-fax"></i></span>
                </div>
                <input type="text" formControlName="fax" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="fax" placeholder="Fax">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="email" class="col-form-label">Email</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
                </div>
                <input type="email" formControlName="email" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="email" placeholder="Email">
              </div>
              <span class="text-danger" *ngIf="formErrors.email"><small>{{formErrors.email}}</small> </span>   
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="web" class="col-form-label">Web</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-globe"></i></span>
                </div>
                <input type="text" formControlName="web" class="form-control" [ngClass]="{'dark-input-field' : isDark }" id="web" placeholder="Web">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="address" class="col-form-label">Address</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                </div>
                <textarea class="form-control" [ngClass]="{'dark-input-field' : isDark }" formControlName="address" id="address" placeholder="Address" rows="3"></textarea>
              </div>
              <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="deliveryAddress" class="col-form-label">Delivery Address</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-shipping-fast"></i></span>
                </div>    
                <textarea class="form-control" [ngClass]="{'dark-input-field' : isDark }" formControlName="deliveryAddress" id="deliveryAddress"  placeholder="Delivery Address" rows="3"></textarea>
              </div>
            </div>
          </div>
        </div>


    
      </div>
      <!-- /.card-body -->
      <div class="card-footer">
        <button *ngIf="crud_access.create"  type="submit" class="btn btn-info ml-2">
         <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>
        <button type="button" *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
      </form>
    </div>
  
    <!-- /.card -->

  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->
